import React from 'react';
import { Pill } from '../../../app/common/sharedComponents/Pill';
import { SquareSection, SquareContainer, VerticalLine } from './styled.score';
import { IScoreValues } from 'src/app/@types/pill';

interface IScoreProps {
  scoreList: IScoreValues[];
}

export const Score: React.FC<IScoreProps> = ({ scoreList }) => {
  return (
    <SquareSection>
      {scoreList &&
        scoreList.map((itemPill, index) => {
          return (
            <>
              <SquareContainer
                key={index}
                backgroundColor={itemPill.backgroundColor}
              >
                <Pill value={itemPill.value} keyValue={itemPill.keyValue} />
              </SquareContainer>
              {itemPill.key === 'Points' && <VerticalLine />}
            </>
          );
        })}
    </SquareSection>
  );
};
